import React from "react";

import { Box, Flex, Text } from "atoms";
import MemoTickWithCircleIcon from "assets/icons/TickWithCircle";
import { toast } from "react-toastify";
import MemoCrossWithCircleIcon from "assets/icons/CrossWithCircle";

import "./toast.notification.css";
const SuccessToast = ({ title, description }) => {
  return (
    <Flex bg="white" aI="center">
      <Box color="success.700" width="1.8rem" height="1.8rem">
        <MemoTickWithCircleIcon width="1.8rem" height="1.8rem" />
      </Box>
      <Box ml="1.6rem">
        {title && (
          <Text variant="bodyLarge" fontWeight="600">
            {title}
          </Text>
        )}
        {description && (
          <Text variant="bodySmall" color="neutral.600">
            {description}
          </Text>
        )}
      </Box>
    </Flex>
  );
};

const ErrorToast = ({ title, description }) => {
  return (
    <Flex bg="white" aI="center">
      <Box color="accents.100" width="1.8rem" height="1.8rem">
        <MemoCrossWithCircleIcon width="1.8rem" height="1.8rem" />
      </Box>
      <Box ml="1.6rem">
        {title && (
          <Text variant="bodyLarge" fontWeight="600">
            {title}
          </Text>
        )}
        {description && (
          <Text variant="bodySmall" color="neutral.600">
            {description}
          </Text>
        )}
      </Box>
    </Flex>
  );
};
export const Toastify = (type, title, description, duration) => {
  switch (type) {
    case "success": {
      toast(<SuccessToast title={title} description={description} />, {
        autoClose: duration || 6000,
      });
      break;
    }

    case "error": {
      toast(<ErrorToast title={title} description={description} />, {
        autoClose: duration || 6000,
      });
      break;
    }

    default:
      break;
  }
};
